import type { BranchDto, BranchType } from 'korint-sdk';

const SECTION_ORDER = ['inProgress', 'denied', 'completed', 'archived', 'calledOff'] as const;

export type BranchSection = (typeof SECTION_ORDER)[number];

type BranchGroup = { section: BranchSection; branches: BranchDto[] };

const classify = (branch: BranchDto): BranchSection | undefined => {
  const { branchStatus, branchType, closeReason } = branch;

  if (branchStatus === 'BRANCH_OPEN') {
    return 'inProgress';
  }
  if (branchStatus === 'BRANCH_MERGED') {
    return 'completed';
  }
  if (branchStatus !== 'BRANCH_CLOSED') {
    return undefined;
  }
  if (branch.derogations?.some(derogation => derogation.status === 'DENIED')) {
    return 'denied';
  }
  // A STOP branch only ever closes FORKED (a denial), BROKER_REQUEST or CUSTOMER_REQUEST.
  if (branchType === 'STOP') {
    return closeReason === 'BROKER_REQUEST' || closeReason === 'CUSTOMER_REQUEST'
      ? 'calledOff'
      : undefined;
  }
  if (closeReason === 'RENEWAL_REFUSED') {
    return 'denied';
  }

  return closeReason === 'BROKER_REQUEST' ? 'archived' : undefined;
};

export const partitionBranches = (branches: BranchDto[], branchType: BranchType): BranchGroup[] =>
  SECTION_ORDER.map(section => ({
    section,
    branches: branches.filter(
      branch => branch.branchType === branchType && classify(branch) === section,
    ),
  })).filter(({ branches }) => branches.length > 0);
